module.exports = __webpack_public_path__ + "img/icon-note-from.ef20c5c0.svg";